import { ProgramCardData, type CardData } from "@/components/Cards/types";
import { AppConstants } from "@/common";
import { useDetailProgramPageStore } from "@/stores/DetailProgramPage";
import type { ExposeInterface } from './types';
import type { ProgramGuideItem, ContentProperties } from '@ca.vmedia.tv/domains';

export const useLinesDetailProgramStore = defineStore('LinesDetailProgram', (): ExposeInterface => {
    const DetailProgramPage = useDetailProgramPageStore();
    const {
        getCurrentChannel: _currentChannel,
        getPrograms: _programs,
        getProgramsProperties,
    } = storeToRefs(DetailProgramPage);

    const getCardsProgram: ComputedRef<CardData[] | null> = computed(() => {
        const data = _programs.value;

        if (data === null || data.items === null) {
            return null;
        }

        if (data.items.length === 0) {
            return [];
        }

        const items: ProgramCardData[] = (data.items as ProgramGuideItem[]).map((item) => new ProgramCardData(item, false));
        if (getProgramsProperties.value.length > 0) {
            items.forEach((program: ProgramCardData) => {
                const id = program.getPlayItem().id;
                if (getProgramsProperties.value) {
                    const prop = getProgramsProperties.value.find((propItem: ContentProperties) => propItem.id == id);
                    program.setPosition(prop?.streamPosition as number);
                }
            });
        }

        return items;
    }); 

    const _counterRows: Ref<number> = ref(AppConstants.DetailCounterLines);
    const getCounterLinesDetailProgram: ComputedRef<number> = computed(() => _counterRows.value);
    const _clearCounter = (): void => {
        _counterRows.value = AppConstants.DetailCounterLines;
    };
    const increaseCounterLinesDetailProgram = (): void => {
        _counterRows.value += 1;
    };

    const clearAllLinesDetailProgram = (): void => {
        _clearCounter();
    };

    return {
        getCardsProgram,
        getCounterLinesDetailProgram,
        increaseCounterLinesDetailProgram,
        clearAllLinesDetailProgram
    };
});
